import { useQuoteDetail } from '@/cms/hooks/quote/useQuoteDetail';
import { Link } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import toast from 'react-hot-toast';

export default function CopyQuoteLink(data: { quoteId: string; source?: string; status?: string; fastQuoteStates?: string }) {
  const { getQuoteRestoreLinkUrl } = useQuoteDetail();

  const copyQuoteUrlAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(getQuoteRestoreLinkUrl({ id: data.quoteId, source: data.source, status: data.status }));
    toast.success('Quote url copied to clipboard');
  };

  return (
    <Tooltip title="Copy quote link" placement="top">
      <Link className="text-brand-secondary ml-2 h-6 w-6 cursor-pointer" onClick={copyQuoteUrlAction} />
    </Tooltip>
  );
}
